// src/contexts/BrandingContext.jsx
// Aplica branding dinamico del workspace al DOM
import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from '../hooks/AuthContext';
import { getWorkspaceBranding } from '../services/brandingService';

const BrandingContext = createContext({});

export const BrandingProvider = ({ children }) => {
  const { user } = useAuth();
  const [branding, setBranding] = useState(null);

  useEffect(() => {
    const load = async () => {
      if (!user?.workspaceId) return;
      try {
        const b = await getWorkspaceBranding(user.workspaceId);
        setBranding(b);

        // Aplicar CSS custom properties al root
        const root = document.documentElement;
        if (b.primaryColor) root.style.setProperty('--brand-primary', b.primaryColor);
        if (b.accentColor) root.style.setProperty('--brand-accent', b.accentColor);
        if (b.sidebarColor) root.style.setProperty('--brand-sidebar', b.sidebarColor);
      } catch {
        // Silently fail - use defaults
      }
    };
    load();

    return () => {
      // Limpiar custom properties al desmontar
      const root = document.documentElement;
      root.style.removeProperty('--brand-primary');
      root.style.removeProperty('--brand-accent');
      root.style.removeProperty('--brand-sidebar');
    };
  }, [user?.workspaceId]);

  return (
    <BrandingContext.Provider value={{ branding, setBranding }}>
      {children}
    </BrandingContext.Provider>
  );
};

export const useBranding = () => useContext(BrandingContext);
